import { FigmaTypography } from "@libs/zapi-ui/custom";
import { ClaudeRunsView } from "./ClaudeRunsView";

export function ClaudeRunsPage() {
  return (
    <div className="container mx-auto py-8 pt-[95px] min-h-[calc(100vh-51px-64px)]" data-testid="claude-runs-page">
      <div className="flex justify-between items-center mb-6">
        <FigmaTypography component="h1" variant="heading-1" data-testid="claude-runs-heading">
          Claude Runs
        </FigmaTypography>
      </div>
      <ClaudeRunsView />
    </div>
  );
}
